import { Component, OnInit } from '@angular/core';
import { FormControl, FormsModule } from '@angular/forms';

import { CommonModule, NgClass } from '@angular/common';
import { KENDO_BUTTON } from '@progress/kendo-angular-buttons';
import { KENDO_DATEPICKER } from '@progress/kendo-angular-dateinputs';
import { KENDO_DROPDOWNS, KENDO_MULTISELECT } from '@progress/kendo-angular-dropdowns';
import { ColumnComponent, ExcelExportComponent, KENDO_EXCELEXPORT } from '@progress/kendo-angular-excel-export';
import { KENDO_GRID_EXCEL_EXPORT } from '@progress/kendo-angular-grid';
import { KENDO_INPUTS, KENDO_OTPINPUT } from '@progress/kendo-angular-inputs';
import { ToastrService } from 'ngx-toastr';
import { AlertService } from '../../@theme/services/alert.service';

@Component({
  selector: 'gd-ngx-accessreports',
  templateUrl: './accessreports.component.html',
  styleUrls: ['./accessreports.component.scss'],
  imports: [
    CommonModule,
    KENDO_BUTTON,
    FormsModule,
    KENDO_DROPDOWNS,
    KENDO_OTPINPUT,
    KENDO_INPUTS,
    KENDO_MULTISELECT,
    KENDO_DATEPICKER,
    KENDO_EXCELEXPORT,
    KENDO_GRID_EXCEL_EXPORT,
    NgClass,
    ExcelExportComponent,
    ColumnComponent,
  ]
})
export class AccessReportsComponent implements OnInit {
  startdate = new FormControl(new Date())
  enddate = new FormControl(new Date())
  gridExcelexport: any[] = []
  ngModelDate = new Date()
  buttonState = 'default-button'
  ngModelendDate = new Date()
  selectedItem = '1'
  public aggregates: any[] = []

  constructor(
    private ur: AlertService,
    private toastrService: ToastrService,
  ) {
    const today = new Date()
    // let gettoday = format(new Date(today), 'yyyy-MM-dd')
    this.ngModelDate = today
    this.ngModelendDate = today
  }
  // eslint-disable-next-line @angular-eslint/no-empty-lifecycle-method
  ngOnInit(): void {
    //\
  }

  onMouseEnter() {
    this.buttonState = 'hover-button'
  }

  onMouseLeave() {
    this.buttonState = 'default-button'
  }
  getAccessreports(component) {
    const Param = { Startdate: this.ngModelDate, Enddate: this.ngModelendDate }
    this.ur.getAccessReports(Param).subscribe((r) => {
      this.gridExcelexport = r
      setTimeout(() => this.returndata(component), 3000)
    })
  }
  returndata(component) {
    const options = component.workbookOptions()
    const rows = options.sheets[0].rows
    let altIdx = 0
    rows.forEach((row) => {
      if (row.type == 'data') {
        if (altIdx % 2 !== 0) {
          row.cells.forEach((cell) => {
            cell.background = '#aabbcc'
          })
        }
        altIdx++
      }
    })
    this.showToast('success', 'Please wait, your Excel is being downloaded.')
    component.save(options)
  }
  ExportToExcel(component) {
    this.getAccessreports(component)
    // this.toastr.success('Program is now creating your excel export.', 'Please wait, will auto download.');
  }
  showToast(status: 'success' | 'error' | 'info' | 'warning', message: string) {
    switch (status) {
      case 'success':
        this.toastrService.success(message, 'Success');
        break;
      case 'error':
        this.toastrService.error(message, 'Error');
        break;
      case 'info':
        this.toastrService.info(message, 'Info');
        break;
      case 'warning':
        this.toastrService.warning(message, 'Warning');
        break;
      default:
        this.toastrService.show(message);
        break;
    }
  }
}


